import { useSearchParams } from 'react-router-dom'
import { CharterMonitoringPanel } from '../../components/Professor/CharterMonitoringPanel'

export default function CharterMonitoringPage() {
  const [searchParams] = useSearchParams()
  const inviteCode = searchParams.get('inviteCode') ?? ''

  return (
    <div className='w-full px-24 pb-10'>
      <CharterMonitoringPanel inviteCode={inviteCode} />
    </div>
  )
}
